import { Auxiliars } from "helpers";
import { IPreference, ISettings } from "interfaces";
import { UserRoleType } from "types";

export interface IUser {
  _id: string;
  first_name: string;
  last_name: string;
  birth_date: string;
  city: string;
  country: string;
  cuisines: string[];
  role: UserRoleType;
  dietary_preference: string;
  allergy: string[];
  no_go: string[];
  preferences?: IPreference[];
  settings: ISettings;
  email: string;
  password?: string;
  full_name?: string;
}

export const createDefaultUser = (): IUser => ({
  _id: Auxiliars.generateObjectId(),
  first_name: "",
  last_name: "",
  birth_date: "",
  city: "",
  country: "",
  cuisines: [],
  dietary_preference: "",
  allergy: [],
  no_go: [],
  preferences: [],
  email: "",
  password: "",
  role: "guest",
  settings: {
    hiddenPotlucks: [],
  } as ISettings,
});